// generated by genversion
export var version = '3.8.16';
//# sourceMappingURL=version.js.map